import { Controller } from '@hotwired/stimulus';
import { observeMutations } from 'helpers/observers';
// Selector to locate the hidden input field and not accidentally select the remove button or something else.
const hiddenInput = 'input[name^="patient[patients_legal_guardians_attributes]["][name$="][legal_guardian_id]"]';

export default class ChooseLegalGuardian extends Controller {
  static targets = ['guardian', 'details'];

  connect() {
    this.connectGuardian();
  }

  connectGuardian() {
    this.hiddenInput.setAttribute('data-choose-legal-guardian-target', 'guardian');
  }

  guardianTargetConnected(element) {
    // Monitor the chosen guardian for changes.
    observeMutations(this.mutate.bind(this), element, { attributeFilter: ['value'], attributeOldValue: true });
  }

  get hiddenInput() {
    return this.element.querySelector(hiddenInput);
  }

  mutate(entries) {
    // Guardian has changed. Update the details link,
    const oldId = entries[0].oldValue;
    const newId = this.guardianTarget.value;
    if (oldId) {
      // If we already had one, swap it out.
      this.detailsTarget.href = this.detailsTarget.href.replace(oldId, newId);
    } else {
      // This is a new one. Complete the link.
      this.detailsTarget.href = this.detailsTarget.href.concat(newId);
    }
  }
}
